import { c as _c } from "react/compiler-runtime";
import type { ReactNode, RefObject } from "react";
import { TweetContainer } from "react-tweet";
import styles from "./ExpandableTweetPreview.module.css";
export default function MeasurementShell(t0) {
  const $ = _c(5);
  const {
    show,
    measureRef,
    children
  } = t0;
  if (!show) {
    return null;
  }
  let t1;
  if ($[0] !== children) {
    t1 = <TweetContainer className="tw-w-full tw-min-w-0 tw-max-w-full">{children}</TweetContainer>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== measureRef || $[3] !== t1) {
    t2 = <div className={styles.measure} ref={measureRef}>{t1}</div>;
    $[2] = measureRef;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}